module.exports = __webpack_public_path__ + "static/img/weixin@2x.bb920451.png";